export default __webpack_public_path__ + "static/media/leopard.153fc509.png";